export default {
    path: "statement",
    menu: { title: "statement.menu", i18n: true },
    permit: "system.quickreplies",
    name: "statement",
    component: () => import("@/views/statement/index.vue")
};
